var GNav = {
  // btn01用のオブジェクト

  path: undefined,
  $targets: undefined,

  init:function () {
    this.nav();
  },

  nav: function() {
    this.$targets = $('.c-gnav').find('li');
    this.$targets.find('a').removeClass('.is-active');
    this.path = location.pathname.split('/')[1];
    switch (this.path){
      case 'about':
        this.addClass(0);
        break;
      case 'participate':
        this.addClass(1);
        break;
      case 'news':
        this.addClass(2);
        break;
      case 'faq':
        this.addClass(3);
        break;
      case 'contact':
        this.addClass(4);
        break;
      case 'en':
        this.path = location.pathname.split('/')[2];
        switch (this.path){
          case 'about':
            this.addClass(0);
            break;
          case 'participate':
            this.addClass(1);
            break;
          default:
          break;
        }
        break;
      default:
      break;
    }
  },

  addClass: function(i) {
    this.$targets.eq(i).find('a').addClass('is-active');
  }

};



module.exports = GNav;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_gNav.js
// module id = 7
// module chunks = 0